(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('sponsors', sponsors);

    /* @ngInject */
    function sponsors() {
        var directive = {
            bindToController: true,
            templateUrl: 'sponsors.tpl',
            controller: sponsorsController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
        }

    }

    /* @ngInject */
    function sponsorsController () {
    }
})();